import Icon from '../components/Icon.vue'

Icon.register({
  skating: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 0c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM400 448c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16-7.2 16-16s7.2-16 16-16zM117.8 456.6c6.3-6.3 16.5-6.2 22.7 0 6.2 6.2 6.2 16.4 0 22.6-9.3 9.3-21.6 14-33.9 14-12.3 0-24.6-4.6-34-14l-67.9-67.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l67.9 67.9c6.2 6.3 16.4 6.2 22.6 0zM173.9 276.8c3.8 6.1 8.2 11.8 13.2 16.8l30.2 30.2-91.9 91.9c-6.2 6.3-14.4 9.4-22.6 9.4s-16.4-3.2-22.6-9.4c-12.5-12.4-12.5-32.7 0-45.2zM128 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h204.6c16.3 0 30.8 9.7 37 24.7 6.2 15 2.8 32.1-8.7 43.6l-82.3 82.3c-0.5 0.5-1.2 0.7-1.7 1.1l61 61c9 8.9 14.1 21.3 14.1 33.9v89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.8l-78.2-78.2c-12.6-12.5-19.4-29.9-18.7-47.7 0.7-17.7 8.8-34.6 22.3-46.1l20.1-17.2h-105.5z'
      }
    ]
  }
})
